export default __webpack_public_path__ + "static/media/008-h.4f94a37c.svg";